import { cn } from '@/lib/utils'
import { ChevronDown, Minus } from 'lucide-react'
import { Checkbox } from '@/components/ui/checkbox'
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'
import { TableCell } from '@/components/ui/table'

// Helper function to check if Instagram Search should be disabled
const isInstagramSearchDisabled = (selectedPlacements) => {
    const instagramFeedSelected = selectedPlacements.includes('instagram:stream')
    return !instagramFeedSelected
}

const PlacementCheckbox = ({ platform, placement, selectedPlacements, handlePlacmentToggle }) => {
    const isInstagramSearch =
        platform.id === 'instagram' && placement.id === 'ig_search' && isInstagramSearchDisabled(selectedPlacements)

    if (!isInstagramSearch) {
        return (
            <Checkbox
                className="tw:transition-transform tw:duration-150 hover:tw:scale-110"
                checked={selectedPlacements.includes(`${platform.id}:${placement.id}`)}
                onCheckedChange={() => handlePlacmentToggle(platform.id, placement.id)}
            />
        )
    }

    return (
        <Tooltip>
            <TooltipTrigger asChild className="tw:flex">
                <div>
                    <Checkbox
                        disabled={true}
                        checked={selectedPlacements.includes(`${platform.id}:${placement.id}`)}
                        onCheckedChange={() => handlePlacmentToggle(platform.id, placement.id)}
                        className="tw:transition-transform tw:duration-150 hover:tw:scale-110 tw:opacity-50 tw:cursor-not-allowed"
                    />
                </div>
            </TooltipTrigger>
            <TooltipContent>
                <label>Instagram Search is only available if Instagram Feed is selected</label>
            </TooltipContent>
        </Tooltip>
    )
}

const CheckboxWithName = ({ platform, placement, selectedPlacements, handlePlacmentToggle }) => {
    const instagramFeedSelected = selectedPlacements.includes('instagram:stream')
    const isInstagramSearchWithoutFeed =
        platform.id === 'instagram' && placement.id === 'ig_search' && !instagramFeedSelected

    return (
        <div className="tw:flex tw:items-center tw:gap-3 tw:pl-7">
            <div className="tw:flex tw:flex-col" onClick={(e) => e.stopPropagation()}>
                <PlacementCheckbox
                    platform={platform}
                    placement={placement}
                    selectedPlacements={selectedPlacements}
                    handlePlacmentToggle={handlePlacmentToggle}
                />
            </div>
            <span className={cn('tw:text-sm tw:text-white', { 'tw:opacity-50': isInstagramSearchWithoutFeed })}>
                {placement.label}
            </span>
        </div>
    )
}

const Cell = ({ isIndeterminate, handlePlatformToggle, platform, isChecked, handleExpandToggle, isExpanded }) => {
    const Icon = platform.icon

    return (
        <TableCell className="tw:pl-3">
            <div className="tw:flex tw:items-center tw:gap-2">
                {isIndeterminate && (
                    <div
                        className="tw:w-4 tw:h-4 tw:bg-blue-300 tw:rounded-xs tw:flex tw:items-center tw:justify-center tw:cursor-pointer"
                        onClick={(e) => {
                            e.stopPropagation()
                            handlePlatformToggle(platform.id)
                        }}
                    >
                        <Minus className="tw:w-3 tw:h-3 tw:text-white" />
                    </div>
                )}

                {!isIndeterminate && (
                    <div className="tw:flex tw:items-center" onClick={(e) => e.stopPropagation()}>
                        <Checkbox checked={isChecked} onCheckedChange={() => handlePlatformToggle(platform.id)} />
                    </div>
                )}
                <div className="tw:flex tw:gap-1 tw:items-center tw:justify-center">
                    <button
                        onClick={(e) => {
                            e.stopPropagation()
                            handleExpandToggle(platform.id)
                        }}
                        className="tw:p-1 tw:rounded tw:text-gray-200 hover:tw:text-white tw:transition-all tw:duration-200 tw:ease-in-out hover:tw:bg-gray-700/10"
                    >
                        <ChevronDown
                            className={cn(
                                'tw:w-4 tw:h-4 tw:transition-transform tw:duration-200 tw:ease-in-out',
                                isExpanded ? 'tw:rotate-0 tw:text-blue-300' : 'tw:-rotate-90',
                            )}
                        />
                    </button>
                    <div className="tw:flex tw:gap-1">
                        <Icon className="tw:w-5 tw:h-5 tw:text-gray-200" />
                        <span className="tw:text-sm tw:text-white">{platform.label}</span>
                    </div>
                </div>
            </div>
        </TableCell>
    )
}

export { PlacementCheckbox, CheckboxWithName, Cell }